import { EventEmitter, Injectable } from '@angular/core';
import { InfoboxService } from './infobox/infobox.service';

@Injectable({
	providedIn: 'root',
})
export class WebsocketService {
	private readonly ws;
	action = new EventEmitter();

	constructor(private readonly infobox: InfoboxService) {
		this.connect();
	}

	connect() {
		// this.ws = new WebSocket("ws://" + location.host + "/ws")
		// this.ws.onmessage = (data)=>{
		// 	this.action.emit(data)
		// }
		// this.ws.onerror = ()=>{
		// 	this.infobox.error("Rozłączono z serwerem")
		// 	setTimeout(() => {
		// 		this.connect()
		// 	}, 5000);
		// }
	}

	send(data) {
		// this.ws.send(data)
	}
}
